<template>
  <div class="panel-button-group">
    <span>{{ data.text }}</span>
    <ck-icon
      v-if="data.icon"
      :name="`ico-${data.icon.name}-${data.icon.size}`"
      :fill="data.icon.fill"
      :size="data.icon.size"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: Object
    /*
    {
      text: '',
      icon: {
        name: 'test',
        fill: 'grey-dark',
        size: '16px'
      }
    }
    */
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.panel-button-group {
  .lh-display(flex);
  .lh-align-items(flex-end);
  .lh-justify-content(center);
  .fontsize-s;
  height: 57px - 19px - 15px; // 19px = panel, padding 15px = margin-bottom hr
  margin-right: -@space-s;
  margin-left: -@space-s;
  color: @blue-400;
  padding-bottom: 2px;
  cursor: pointer;

  .ico:not(:only-child) {
    margin-left: @space-xxs;
  }
}
</style>
